import { render, staticRenderFns } from "./NumberManagement.vue?vue&type=template&id=0d05af34&scoped=true&"
import script from "./NumberManagement.vue?vue&type=script&lang=js&"
export * from "./NumberManagement.vue?vue&type=script&lang=js&"
import style0 from "./NumberManagement.vue?vue&type=style&index=0&id=0d05af34&scoped=true&lang=css&"
import style1 from "./NumberManagement.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d05af34",
  null
  
)

export default component.exports